import { render, staticRenderFns } from "./NewPaymentInfo.vue?vue&type=template&id=860a3de4"
import script from "./NewPaymentInfo.vue?vue&type=script&lang=js"
export * from "./NewPaymentInfo.vue?vue&type=script&lang=js"
import style0 from "./NewPaymentInfo.vue?vue&type=style&index=0&id=860a3de4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports